<div class="profile-container">
  <!-- Profile Header -->
  <div class="profile-header">
    <div class="profile-card">
      @if (isLoading) {
        <!-- Profile Loading Skeleton -->
        <div class="profile-skeleton">
          <div class="skeleton-image"></div>
          <div class="skeleton-status"></div>
          <div class="skeleton-name"></div>
          <div class="skeleton-email"></div>
          <div class="skeleton-rating">
            <div class="skeleton-rating-item"></div>
            <div class="skeleton-rating-item"></div>
          </div>
        </div>
      } @else {
        <!-- Profile Image Section -->
        <div class="profile-image-section">
          <div class="profile-image-wrapper">
            <img [src]="user?.image || 'icons/waiter.svg'"
                 class="profile-image"
                 alt="Profile Picture">
            <div class="profile-image-overlay">
              <i class="fa fa-camera"></i>
            </div>
          </div>
          <div class="profile-status">
            <span class="status-indicator active"></span>
            <span class="status-text">Active</span>
          </div>
        </div>

        <!-- Profile Info Section -->
        <div class="profile-info">
          <h2 class="profile-name">{{ user?.first_name + ' ' + user?.last_name }}</h2>
          <p class="profile-email">{{ user?.email }}</p>

          <!-- Rating Section -->
          <div class="rating-section">
            <div class="rating-display">
              <i class="fa fa-star rating-star"></i>
              <span class="rating-value">4.90</span>
              <span class="rating-label">Rating</span>
            </div>
            <div class="rating-badge">
              <i class="fa fa-award"></i>
              <span>Top Performer</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Profile Stats -->
  <div class="profile-stats">
    @if (isLoadingStats) {
      <!-- Stats Loading Skeleton -->
      <div class="stats-skeleton">
        <div class="skeleton-stat">
          <div class="skeleton-stat-icon"></div>
          <div class="skeleton-stat-content">
            <div class="skeleton-stat-value"></div>
            <div class="skeleton-stat-label"></div>
          </div>
        </div>
        <div class="skeleton-stat">
          <div class="skeleton-stat-icon"></div>
          <div class="skeleton-stat-content">
            <div class="skeleton-stat-value"></div>
            <div class="skeleton-stat-label"></div>
          </div>
        </div>
        <div class="skeleton-stat">
          <div class="skeleton-stat-icon"></div>
          <div class="skeleton-stat-content">
            <div class="skeleton-stat-value"></div>
            <div class="skeleton-stat-label"></div>
          </div>
        </div>
      </div>
    } @else {
      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-icon orders-icon">
            <i class="fa fa-clipboard-list"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">{{ stats.orders }}</h3>
            <p class="stat-label">Orders Served</p>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon revenue-icon">
            <i class="fa fa-chart-line"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">₦{{ stats.revenue | number }}</h3>
            <p class="stat-label">Total Revenue</p>
          </div>
        </div>

        <div class="stat-item">
          <div class="stat-icon time-icon">
            <i class="fa fa-clock"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-value">{{ stats.responseTime }}</h3>
            <p class="stat-label">Avg. Response</p>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Profile Menu -->
  <div class="profile-menu">
    <div class="menu-section">
      <h3 class="section-title">Account Settings</h3>
      <div class="menu-items">
        <button class="menu-item">
          <div class="menu-item-icon">
            <i class="fa fa-user-edit"></i>
          </div>
          <div class="menu-item-content">
            <span class="menu-item-title">Edit Profile</span>
            <span class="menu-item-subtitle">Update your personal information</span>
          </div>
          <i class="fa fa-chevron-right menu-item-arrow"></i>
        </button>

        <button class="menu-item">
          <div class="menu-item-icon">
            <i class="fa fa-bell"></i>
          </div>
          <div class="menu-item-content">
            <span class="menu-item-title">Notifications</span>
            <span class="menu-item-subtitle">Manage your notification preferences</span>
          </div>
          <i class="fa fa-chevron-right menu-item-arrow"></i>
        </button>

        <button class="menu-item">
          <div class="menu-item-icon">
            <i class="fa fa-shield-alt"></i>
          </div>
          <div class="menu-item-content">
            <span class="menu-item-title">Privacy & Security</span>
            <span class="menu-item-subtitle">Password and security settings</span>
          </div>
          <i class="fa fa-chevron-right menu-item-arrow"></i>
        </button>
      </div>
    </div>

    <div class="menu-section">
      <h3 class="section-title">Support</h3>
      <div class="menu-items">
        <button class="menu-item">
          <div class="menu-item-icon">
            <i class="fa fa-question-circle"></i>
          </div>
          <div class="menu-item-content">
            <span class="menu-item-title">Help & Support</span>
            <span class="menu-item-subtitle">Get help when you need it</span>
          </div>
          <i class="fa fa-chevron-right menu-item-arrow"></i>
        </button>

        <button class="menu-item">
          <div class="menu-item-icon">
            <i class="fa fa-info-circle"></i>
          </div>
          <div class="menu-item-content">
            <span class="menu-item-title">About HMS Waiter</span>
            <span class="menu-item-subtitle">Version 2.1.0</span>
          </div>
          <i class="fa fa-chevron-right menu-item-arrow"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Logout Section -->
  <div class="logout-section">
    <button class="logout-btn" [class.loading]="isLoggingOut" (click)="logout()" [disabled]="isLoggingOut">
      <div class="logout-content">
        <div class="logout-icon">
          @if (isLoggingOut) {
            <div class="spinner"></div>
          } @else {
            <i class="fa fa-sign-out-alt"></i>
          }
        </div>
        <div class="logout-text">
          <span class="logout-title">
            {{ isLoggingOut ? 'Signing Out...' : 'Sign Out' }}
          </span>
          <span class="logout-subtitle">
            {{ isLoggingOut ? 'Please wait' : "You'll need to sign in again" }}
          </span>
        </div>
      </div>
      @if (!isLoggingOut) {
        <i class="fa fa-chevron-right logout-arrow"></i>
      }
    </button>
  </div>
</div>
